/* eslint-disable  no-undef */

/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import {configTW, configIN} from './regionalConfigs';

// Personal
// const CLIENT_ID = '0oa582zubbGkSLBnC5d7';
// const ISSUER = 'https://dev-26499474.okta.com/oauth2/default';
// const OKTA_TESTING_DISABLEHTTPSCHECK =
//   process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;
// const BASENAME = process.env.PUBLIC_URL || "";
// const REDIRECT_URI = 'http://localhost:3000/dashboard';
// const USE_INTERACTION_CODE =
//   process.env.USE_INTERACTION_CODE === "true" || false;

// Amway DEV
// const CLIENT_ID = "0oa1oqgzkgdxxEXTi0h8";
// const ISSUER = "https://amway.okta.com/oauth2/aus1h78lyb8aJ7EBp0h8";
// const OKTA_TESTING_DISABLEHTTPSCHECK =
//   process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;
// const BASENAME = process.env.PUBLIC_URL || "";
// const REDIRECT_URI = 'https://dev.admin.tw.academy.amway.com/dashboard';
// const USE_INTERACTION_CODE =
//   process.env.USE_INTERACTION_CODE === "true" || false;

// Amway QA
// const CLIENT_ID = "0oa1ov5i6oadXNvYf0h8";
// const ISSUER = "https://amway.okta.com/oauth2/aus1h78lyb8aJ7EBp0h8";
// const OKTA_TESTING_DISABLEHTTPSCHECK =
//   process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;
// const BASENAME = process.env.PUBLIC_URL || "";
// const REDIRECT_URI = 'https://qa.admin.tw.academy.amway.com/dashboard';
// const USE_INTERACTION_CODE =
//   process.env.USE_INTERACTION_CODE === "true" || false;

export default {
  resourceServer: {
    messagesUrl: 'http://localhost:8000/api/messages',
  },
  app: {
    basename: process.env.PUBLIC_URL || '',
  },
  currentRegion: process.env.REACT_APP_CURRENT_REGION || '',
  currentEnv: process.env.REACT_APP_CURRENT_ENV || '',
  ...configTW,
  ...configIN,
};
